fragment GenericIframeFragment on genericIframe_Entry {
  typeHandle
  iframeCode
  isContained
}
